
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loading",
      function () {
        return require("private-next-pages/loading.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loading"])
      });
    }
  